export const calendarSwitchSx = (theme) => ({
                    '& .MuiSwitch-track': {
                      backgroundColor: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                      opacity: 1,
                      border: '1px solid',
                      borderColor: theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b',
                      boxSizing: 'border-box',
                    },
                    '& .MuiSwitch-switchBase': {
                      color: '#ffffff',
                      '&.Mui-checked': { color: '#ffffff' },
                      '&.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#2563eb', borderColor: '#60a5fa', opacity: 1,
                      },
                      '&.Mui-disabled + .MuiSwitch-track': { opacity: 0.5 },
                    },
                  });
